import {IPFS} from "ipfs-core"
import KeyValueStore from "orbit-db-kvstore"
import {useCallback, useContext, useEffect, useState} from "react"
import {AppConfig} from "../App.config"
import {BackendContext} from "../context/BackendContext"
import {concat} from "uint8arrays"
import all from "it-all"

export const useAvatar = (profile?: KeyValueStore<any>, profileReplCnt?: number) => {
  const {ipfs} = useContext(BackendContext)
  const [avatar, setAvatar] = useState(AppConfig.defaultAvatar)

  const getAvatar = useCallback(async (ipfs: IPFS, profile: KeyValueStore<any>) => {
    const cid = profile.get("avatar_cid")
    if (!cid) {
      return
    }
    const uint8array = concat(await all(ipfs.cat(cid)))
    const buffer = Buffer.from(uint8array)
    const base64 = `data:image/png;base64,${buffer.toString("base64")}`
    setAvatar(base64)
  }, [])

  useEffect(() => {
    if (!ipfs || !profile || profileReplCnt === undefined) {
      return
    }
    getAvatar(ipfs, profile).then()
  }, [ipfs, profile, profileReplCnt])

  return {
    avatar: avatar ?? AppConfig.defaultAvatar
  }
}

